<template>
  <div class="bg-gray-50 px-4 py-6 sm:px-6">
    <div class="max-w-7xl mx-auto">
      <div
        class="mb-8 flex flex-col gap-6 md:flex-row md:items-center md:justify-between"
      >
        <div>
          <h1 class="text-2xl font-semibold text-neutral-text mb-2">
            Spaces Management
          </h1>
          <div class="flex items-center gap-2">
            <span class="text-neutral-light">Total Spaces</span>
            <span
              class="bg-primary/10 text-primary-neutral text-sm font-medium px-2.5 py-0.5 rounded-full"
            >
              {{ totalSpaces }}
            </span>
          </div>
        </div>
        <div
          class="flex w-full flex-row gap-2 sm:gap-3 sm:flex-row sm:flex-wrap md:w-auto md:justify-end"
        >
          <ActionButton
            action="add"
            variant="secondary"
            class="flex-1 py-2 text-xs sm:w-auto sm:py-2 sm:text-xs"
            @click="addSpace"
          >
            Add Space
          </ActionButton>
          <ActionButton
            action="filter"
            :active="showFilters"
            class="flex-1 py-2 text-xs sm:w-auto sm:py-2 sm:text-xs"
            @click="toggleFilters"
          >
            Filter
          </ActionButton>
        </div>
      </div>
      <SpaceDataTable
        ref="spaceDataTableRef"
        @update-total="updateTotalSpaces"
        :show-filters="showFilters"
      />
    </div>
  </div>
</template>

<script setup>
import SpaceDataTable from "@/components/dashboard/SpaceDataTable.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import { ref } from "vue";

const totalSpaces = ref(0);
const showFilters = ref(false);
const spaceDataTableRef = ref(null);

const updateTotalSpaces = (count) => {
  totalSpaces.value = count;
};

const toggleFilters = () => {
  showFilters.value = !showFilters.value;
};

const addSpace = () => {
  if (spaceDataTableRef.value) {
    spaceDataTableRef.value.toggleSpaceForm();
  }
};
</script>

<style scoped>
.collapsed {
  display: -webkit-box;
  -webkit-line-clamp: var(--line-clamp);
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.expanded {
  display: block;
}
</style>
